import * as React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import LinearProgress from '@mui/material/LinearProgress';
import PropTypes from 'prop-types';
import Box from '@mui/joy/Box';
import Table from '@mui/joy/Table';
import Typography from '@mui/joy/Typography';
import Sheet from '@mui/joy/Sheet';
import Checkbox from '@mui/joy/Checkbox';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import IconButton from '@mui/joy/IconButton';
import Link from '@mui/joy/Link';
import Tooltip from '@mui/joy/Tooltip';
import Select from '@mui/joy/Select';
import Option from '@mui/joy/Option';
import DeleteIcon from '@mui/icons-material/Delete';
import FilterListIcon from '@mui/icons-material/FilterList';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { visuallyHidden } from '@mui/utils';
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import Button from '@mui/joy/Button';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import Grid from '@mui/joy/Grid';
import Input from '@mui/joy/Input';

/////////////////// Modal
import Modal from '@mui/joy/Modal';
import ModalDialog from '@mui/joy/ModalDialog';

//////////////// Alert
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';



////////////////////// Icons Images
import DeleteIconImage from '../../../assets/icons/trashCar.svg'
import EditIconImage from '../../../assets/icons/eiditIconMove.svg'
import DubleIcon from '../../../assets/icons/dubleIcon.svg'
import CarBrandImage from '../../../assets/bmw.png'


import SearchIcon from '@mui/icons-material/Search';


///////////////////// API
import { getAllModels, deleteModels } from '../../../Api/ModelCar';


function createData(title_ar, title_en, image, actions) {
    return {
        title_ar,
        title_en,
        image,
        actions
    };
}


function labelDisplayedRows({ from, to, count }) {
    return `${from}–${to} of ${count !== -1 ? count : `more than ${to}`}`;
}

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}


// Since 2020 all major browsers ensure sort stability with Array.prototype.sort().
// stableSort() brings sort stability to non-modern browsers (notably IE11). If you
// only support modern browsers you can replace stableSort(exampleArray, exampleComparator)
// with exampleArray.slice().sort(exampleComparator)
function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
            return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

const headCells = [
    {
        id: 'brand',
        numeric: false,
        disablePadding: true,
        label: 'الماركة',
    },
    {
        id: 'title_ar',
        numeric: false,
        disablePadding: true,
        label: 'الموديلات باللغة العربية',
    },
    {
        id: 'title_en',
        numeric: true,
        disablePadding: false,
        label: 'الموديلات باللغة الانجليزية',
    },
    // {
    //     id: 'image',
    //     numeric: true,
    //     disablePadding: false,
    //     label: 'الشعار',
    // },
    {
        id: 'actions',
        numeric: true,
        disablePadding: false,
        label: 'الاجراءات',
    },
];

function EnhancedTableHead(props) {
    const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } =
        props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <>
            <thead>
                <tr style={
                    { 'background': '#F3F3F3', 'color': '#7C7C7C', fontWeight: 'bold' }
                }>
                    {headCells.map((headCell) => {
                        const active = orderBy === headCell.id;
                        return (
                            <th
                                key={headCell.id}
                                aria-sort={
                                    active ? { asc: 'ascending', desc: 'descending' }[order] : undefined
                                }
                            >
                                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                <Link
                                    underline="none"
                                    color="neutral"
                                    textColor={active ? 'primary.plainColor' : undefined}
                                    component="button"
                                    onClick={createSortHandler(headCell.id)}
                                    fontWeight="lg"
                                    startDecorator={
                                        headCell.numeric ? (
                                            <ArrowDownwardIcon sx={{ opacity: active ? 1 : 0 }} />
                                        ) : null
                                    }
                                    endDecorator={
                                        !headCell.numeric ? (
                                            <ArrowDownwardIcon sx={{ opacity: active ? 1 : 0 }} />
                                        ) : null
                                    }
                                    sx={{
                                        '& svg': {
                                            transition: '0.2s',
                                            transform:
                                                active && order === 'desc' ? 'rotate(0deg)' : 'rotate(180deg)',
                                        },
                                        '&:hover': { '& svg': { opacity: 1 } },
                                    }}
                                >
                                    {headCell.label}
                                    {active ? (
                                        <Box component="span" sx={visuallyHidden}>
                                            {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                        </Box>
                                    ) : null}
                                </Link>
                            </th>
                        );
                    })}
                </tr>
            </thead>
        </>

    );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

function EnhancedTableToolbar(props) {
    const { numSelected } = props;

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                py: 1,
                pl: { sm: 2 },
                pr: { xs: 1, sm: 1 },
                ...(numSelected > 0 && {
                    bgcolor: 'background.level1',
                }),
                borderTopLeftRadius: 'var(--unstable_actionRadius)',
                borderTopRightRadius: 'var(--unstable_actionRadius)',
            }}
        >
            {numSelected > 0 ? (
                <Typography sx={{ flex: '1 1 100%' }} component="div">
                    {numSelected} selected
                </Typography>
            ) : (
                <Typography
                    level="body-lg"
                    sx={{ flex: '1 1 100%' }}
                    id="tableTitle"
                    component="div"
                >
                    Nutrition
                </Typography>
            )}

            {numSelected > 0 ? (
                <Tooltip title="Delete">
                    <IconButton size="sm" color="danger" variant="solid">
                        <img src={DeleteIconImage} alt='icon delete' />
                    </IconButton>
                </Tooltip>
            ) : false}
        </Box>
    );
}

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


export default function TableCarModal() {
    const navigate = useNavigate()
    const [filter, setFilter] = React.useState({ page: 1 })
    const [countPage, setCountPage] = React.useState(0)
    // let objFilter = { page: 1 }

    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('calories');
    const [selected, setSelected] = React.useState([]);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [rows, setRows] = React.useState([])
    const [modelId, setModelId] = React.useState(null)
    const [openModalConfirm, setOpenModalConfirm] = React.useState(false)

    const [loadingData, setLoadingData] = React.useState(false)
    const [loading, setLoading] = React.useState(false)
    const [openAlert, setOpenAlert] = React.useState(false);
    const [messageAlert, setMessageAlert] = React.useState('');

    const [openAlertError, setOpenAlertError] = React.useState(false);
    const [messageAlertError, setMessageAlertError] = React.useState('');
    const [searchData, setSearchData] = React.useState(null);


    const [roleId, setRoleId] = React.useState([])
    const [adminType, setAdminType] = React.useState(null)
    let objFilterPagintion = {
        page: 1,
        search: ""
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const handleCloseAlertError = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlertError(false);
    };


    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelected = rows.map((n) => n.name);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        setSelected(newSelected);
    };


    const openConfirmDelete = (id) => {
        setModelId(id)
        setOpenModalConfirm(true)
    };

    const deleteBrand = async () => {
        setLoading(true)
        const res = await deleteModels(modelId)
        if (res) {
            setLoading(false);
            setMessageAlert("تم حذف الموديل بنجاح")
            setOpenAlert(true)
            setModelId(null)
            setOpenModalConfirm(false)
            getAllData()
        }
    }

    const getAllData = React.useCallback(async () => {
        setLoadingData(true)
        const res = await getAllModels(objFilterPagintion);
        if (res) {
            setLoadingData(false)
            setRows(res.data)
            setCountPage(res.last_page)
        }
    }, [])

    const handleChangePagePagintion = async (e, newValuePage) => {
        objFilterPagintion.page = newValuePage
        objFilterPagintion.search = objFilterPagintion.search
        const res = await getAllModels(objFilterPagintion);
        // console.log(res.data)
        if (res) {
            setRows(res.data)
            setCountPage(res.last_page)
        }
        // console.log("newValuePage > ", newValuePage)
        // setFilter(prev => ({
        //     ...prev,
        //     page: newValuePage, // update only the 'age' property
        //   }));
        // objFilter.page = newValuePage
        // getAllData();
    }

    React.useEffect(() => {
        getAllData();
    }, [getAllData])

    const getSearchData = async (e) => {
        setLoadingData(true)
        if (e.target.value) {
            objFilterPagintion.search = e.target.value
            // objFilterPagintion.page = objFilterPagintion.page


            const res = await getAllModels(objFilterPagintion)
            if (!res.data) {
                setLoadingData(false)
                setRows([])
                setCountPage(0)
                return
            }
            setLoadingData(false)
            setRows(res.data)
            setCountPage(res.last_page)
        } else {
            getAllData()
        }

    }


    const getRoleAamin = React.useCallback(async () => {
        let role = await JSON.parse(localStorage.getItem("adminRoleSoomha"));
        let typeAdmin = await JSON.parse(localStorage.getItem("typeAdminSoomha"));
        let roles = role.map((roleIds) => {
            return roleIds.role_id
        })
        let numberArray = roles.map(Number);
        setRoleId(numberArray)
        setAdminType(typeAdmin)
    }, [])

    React.useEffect(() => {
        getRoleAamin()
    }, [getRoleAamin])

    const isSelected = (name) => selected.indexOf(name) !== -1;

    // Avoid a layout jump when reaching the last page with empty rows.
    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

    return (
        <>

            {/* Alert Message */}
            <Snackbar open={openAlert} autoHideDuration={6000} onClose={handleClose}>
                <Alert severity="success">{messageAlert}</Alert>
            </Snackbar>

            <Snackbar open={openAlertError} autoHideDuration={6000} onClose={handleCloseAlertError}>
                <Alert onClose={handleCloseAlertError} severity="warning" sx={{ width: '100%' }}>
                    {messageAlertError}
                </Alert>
            </Snackbar>

            {/* Modal PopUp */}
            <Modal open={openModalConfirm} onClose={() => setOpenModalConfirm(false)}>
                <ModalDialog
                    aria-labelledby="nested-modal-title"
                    aria-describedby="nested-modal-description"
                    sx={(theme) => ({
                        [theme.breakpoints.only('xs')]: {
                            top: 'unset',
                            bottom: 0,
                            left: 0,
                            right: 0,
                            borderRadius: 0,
                            transform: 'none',
                            maxWidth: 'unset',
                        },
                        direction: 'rtl'
                    })}
                >
                    <Typography id="nested-modal-title" level="h2">
                        هل انت متاكد من حذف الموديل ؟
                    </Typography>
                    <Typography id="nested-modal-description" textColor="text.tertiary">
                        لا يمكن التراجع عن هذا الإجراء. سيؤدي هذا إلى حذف الموديل بشكل دائم وإزالة بياناتك من خوادمنا.
                    </Typography>
                    <Box
                        sx={{
                            mt: 1,
                            display: 'flex',
                            gap: 1,
                            flexDirection: { xs: 'column', sm: 'row-reverse' },
                        }}
                    >
                        <Button variant="solid" color="primary" onClick={() => deleteBrand()}>
                            تأكيد
                        </Button>
                        <Button
                            variant="outlined"
                            color="neutral"
                            onClick={() => setOpenModalConfirm(false)}
                        >
                            الغاء
                        </Button>
                    </Box>
                </ModalDialog>
            </Modal>

            <Grid container xs={8} sx={{ marginBottom: '30px', marginTop: '-80px' }}>
                <Grid xs={8}>
                    <Input
                        placeholder="ابحث باسم الموديل"
                        onChange={(e) => getSearchData(e)}
                        sx={{
                            '--Input-focusedInset': 'var(--any, )',
                            '--Input-focusedThickness': '0.25rem',
                            '--Input-focusedHighlight': 'rgba(13,110,253,.25)',
                            '&::before': {
                                transition: 'box-shadow .15s ease-in-out',
                            },
                            '&:focus-within': {
                                borderColor: '#B9B9B9',
                            },
                            width: '100%',
                            height: '45px',
                            borderRadius: '32px',
                            color: '#B9B9B9'
                        }}
                        startDecorator={<SearchIcon sx={{ color: '#B9B9B9' }} />}

                    />
                </Grid>
            </Grid>

            <Sheet
                variant="outlined"
                sx={{ width: '100%', boxShadow: 'sm', borderRadius: 'sm' }}
            >
                {/* <EnhancedTableToolbar numSelected={selected.length} /> */}
                <Table
                    aria-labelledby="tableTitle"
                    hoverRow
                    sx={{
                        '--TableCell-headBackground': 'transparent',
                        '--TableCell-selectedBackground': (theme) =>
                            theme.vars.palette.success.softBg,
                        // '& thead th:nth-child(1)': {
                        //     width: '40px',
                        // },

                        '& tr > *:nth-child(n+3)': { textAlign: 'center' },
                        '& tr > *:nth-child(1)': { textAlign: 'center' },
                        '& tr > *:nth-child(2)': { textAlign: 'center' },
                    }}
                >
                    <EnhancedTableHead
                        numSelected={selected.length}
                        order={order}
                        orderBy={orderBy}
                        onSelectAllClick={handleSelectAllClick}
                        onRequestSort={handleRequestSort}
                        rowCount={rows.length}
                    />
                    <tbody>
                        {stableSort(rows, getComparator(order, orderBy))
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((row, index) => {
                                const isItemSelected = isSelected(row.name);
                                const labelId = `enhanced-table-checkbox-${index}`;

                                return (
                                    <tr
                                        onClick={(event) => handleClick(event, row.name)}
                                        role="checkbox"
                                        aria-checked={isItemSelected}
                                        tabIndex={-1}
                                        key={row.name}
                                        // selected={isItemSelected}
                                        style={
                                            isItemSelected
                                                ? {
                                                    '--TableCell-dataBackground':
                                                        'var(--TableCell-selectedBackground)',
                                                    '--TableCell-headBackground':
                                                        'var(--TableCell-selectedBackground)',
                                                }
                                                : {}
                                        }
                                    >
                                        <th id={labelId} scope="row">
                                            {row.brand ? row.brand.title_ar + ' - ' + row.brand.title_en : "لايوجد بيانات"}
                                        </th>
                                        <th id={labelId} scope="row">
                                            {row.name_ar ? row.name_ar : "لايوجد بيانات"}
                                        </th>
                                        <th id={labelId} scope="row">
                                            {row.name_en ? row.name_en : "لايوجد بيانات"}
                                        </th>
                                        {/* <th id={labelId} scope="row">
                                            {row.brand ? (
                                                <img src={row.brand.image} width='50px' height='50px' alt='brand' />

                                            ) : (
                                                <Typography level='p' sx={{ textAlign: 'center' }}>لا توجد صورة</Typography>
                                            )}
                                        </th> */}

                                        <td>
                                            {(adminType == 0) ? (
                                                <>
                                                    <IconButton variant='plain'>
                                                        <img src={DeleteIconImage} alt='delete icon' onClick={() => openConfirmDelete(row.id)} />
                                                    </IconButton>
                                                    <IconButton variant='plain' onClick={() => navigate('/cars/edit-model/' + row.id)}>
                                                        <img src={EditIconImage} alt='edit icon' />
                                                    </IconButton>
                                                    <IconButton variant='plain'>
                                                        <img src={DubleIcon} alt='duble icon' onClick={() => navigate('/cars/imitation-model/' + row.id)} />
                                                    </IconButton>
                                                </>
                                            ) : null}

                                            {(roleId.includes(4)) ? (
                                                <IconButton variant='plain' onClick={() => navigate('/cars/edit-model/' + row.id)}>
                                                    <img src={EditIconImage} alt='edit icon' />
                                                </IconButton>
                                            ) : null}

                                            {/* <IconButton variant='plain'>
                                                <img src={DeleteIconImage} alt='delete icon' onClick={() => openConfirmDelete(row.id)} />
                                            </IconButton>
                                            <IconButton variant='plain' onClick={() => navigate('/cars/edit-model/' + row.id)}>
                                                <img src={EditIconImage} alt='edit icon' />
                                            </IconButton>
                                            <IconButton variant='plain'>
                                                <img src={DubleIcon} alt='duble icon' onClick={() => navigate('/cars/imitation-model/' + row.id)} />
                                            </IconButton> */}

                                            {/* <IconButton variant='plain'>
                                                <AutoFixHighIcon 
                                                    color='primary' 
                                                    sx={{fontSize:'20px'}} 
                                                    onClick={() => navigate('/cars/editAll-models-in-Brand/' + row.id)}/>
                                            </IconButton> */}

                                        </td>
                                    </tr>
                                );
                            })}
                        {emptyRows > 0 && (
                            <tr
                                style={{
                                    height: `calc(${emptyRows} * 40px)`,
                                    '--TableRow-hoverBackground': 'transparent',
                                }}
                            >
                                <td colSpan={6} aria-hidden />
                            </tr>
                        )}
                    </tbody>

                </Table>
            </Sheet>
            {loadingData ? (
                <LinearProgress />
            ) : null}
            <Stack spacing={2} alignItems='center' mt='30px'>
                <Pagination count={countPage} color="primary" sx={{ margin: 'auto', direction: 'ltr' }} onChange={handleChangePagePagintion} />
            </Stack>
        </>
    );
}